export default __webpack_public_path__ + "static/media/223.5ec50270.jpg";